// extracted by mini-css-extract-plugin
module.exports = {"container":"CardsSkeleton_container__kO5YC","product_skeleton_card_container":"CardsSkeleton_product_skeleton_card_container___dg3J","show-map":"CardsSkeleton_show-map__vNFlT"};